var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',{staticClass:"justify-content-center"},[_c('b-col',{attrs:{"cols":_vm.cols,"sm":_vm.sm,"md":_vm.md,"lg":_vm.lg,"xl":_vm.xl}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }